<ng-container *ngIf="isLoading; else viewPartners">
  <div fxLayout="column" fxLayoutAlign="center center" style="height: 100vh">
    <uni-loader></uni-loader>
  </div>
</ng-container>

<ng-template #viewPartners>
  <div *ngFor="let module of modules">
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px" class="module-title-wrapper">
      <h3 class="font-lg font-bold spacing margin-0" >{{ module.sub_heading | uppercase }} </h3>
      <mat-divider class="width-100 border-top-width-3"></mat-divider>
    </div>

    <div *ngIf="module.desc" class="desc-wrapper">
      <div class="desc content-desc" [innerHtml]="module.desc"></div>
    </div>

    <div *ngIf="module.partners">
      <div class="wrapper">
        <div *ngFor="let partner of module.partners" fxLayout.gt-xs="row" fxLayout="column" fxLayoutGap="24px"
          fxLayoutAlign="start start">
          <a [href]="partner.organization.website" target="_blank" class="no-decor">
            <uni-image
              [src]="partner.organization.logo"
              [default]="defaultImage"
              classes="partner-image rounded-border fit-cover fx-inline-block cursor-pointer" 
              [alt]="partner.organization.title"
              [height]="64"
              [width]="64">
            </uni-image></a>
          <!-- <div fxLayout="column" fxLayoutAlign="start start">
          </div> -->
          <div class="text-container">
            <a [href]="partner.organization.website" target="_blank" class="no-decor">
              <h4 class="font-md font-bold sparro-grey-900 margin-top-0 cursor-pointer">
                {{ partner.organization.title }}
              </h4>
            </a>
            <p class="font-sm sparro-grey-900 margin-0">{{ partner.organization.tagline }}</p>
          </div>
        </div>
      </div>
    </div>

    <ng-container *ngIf="module.button_submodule">
      <div *ngFor="let buttonModule of module.button_submodule;">
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="1.25rem" class="module-title-wrapper">
          <h3 class="font-md font-bold spacing margin-0" *ngIf="buttonModule.sub_heading.toLowerCase() !== module.sub_heading.toLowerCase()">
            {{ buttonModule.sub_heading }}
          </h3>
          <mat-divider *ngIf="buttonModule.sub_heading.toLowerCase() !== module.sub_heading.toLowerCase()" style="border-top-width: 4px; width: 100%">
          </mat-divider>
        </div>

        <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="100px" class="margin-bottom-6">
          <ng-container *ngFor="let button of buttonModule.buttons">
            <uni-navigation-button
              default="{{ button.title | uppercase }}"
              button_class="secondary"
              (click)="openLink(button.link)">
            </uni-navigation-button>
          </ng-container>
        </div>

        <div *ngIf="buttonModule.desc" class="desc-wrapper text-center">
          <div class="button-desc sparro-grey-800" [innerHtml]="buttonModule.desc"></div>
        </div>
      </div>
    </ng-container>
  </div>
</ng-template>
